// extracted by mini-css-extract-plugin
module.exports = {"popover":"components-base-CustomPopover-CustomPopover__popover--z_K3d"};